import type { FC, PropsWithChildren } from 'react'

import styled from '@emotion/styled'

import Section from '@segment/matcha/recipes/Section'

import TestimonialSlider from '@segment/templates/TestimonialSlider'

import { testimonialData } from './data'

const Testimonials: FC<PropsWithChildren<unknown>> = () => {
  return (
    <StyledSection variant="noCopy">
      <TestimonialSlider innerStyles={false} title={false} data={testimonialData} />
    </StyledSection>
  )
}

const StyledSection = styled(Section)`
  max-width: 1260px;
  overflow-x: inherit;
`

export default Testimonials
